import React from "react";
import PropTypes from "prop-types";
import { Button } from "antd";

import { IconLight } from "../../components";
import { REPORT_ACTIONS } from "../_utils/constants";
import { CsvDownload } from "../csv_download";

const buttonProps = {
  // size: "small",
  // type: "primary",
  // ghost: true,
  //shape: "circle",
  style: {
    marginLeft: "8px"
  }
};

const CoreReportActionBar = ({
  isActive,
  onAction,
  reportData,
  isFullScreen
}) => {
  const onButtonClick = action => () => {
    onAction(action);
  };
  return (
    <div
      style={{
        visibility: isActive ? "visible" : "hidden",
        float: "right",
        marginTop: "8px",
        marginRight: "8px"
      }}
    >
      <Button
        {...buttonProps}
        //type={"primary"}
        title={"Run report"}
        onClick={onButtonClick(REPORT_ACTIONS.RUN_REPORT)}
      >
        <IconLight icon={"play"} /> Run
      </Button>
      {/*<Button*/}
      {/*{...buttonProps}*/}
      {/*title={"Save"}*/}
      {/*onClick={onButtonClick(REPORT_ACTIONS.SAVE)}*/}
      {/*>*/}
      {/*<IconLight icon={"save"} />*/}
      {/*</Button>*/}
      {reportData &&
        reportData.length > 0 && (
          <CsvDownload data={reportData} style={buttonProps.style} />
        )}

      {/*<Button*/}
      {/*{...buttonProps}*/}
      {/*shape={"circle"}*/}
      {/*title={"open report properties"}*/}
      {/*onClick={onButtonClick(REPORT_ACTIONS.OPEN_REPORT_PROPS)}*/}
      {/*>*/}
      {/*<IconLight icon={"edit"} />*/}
      {/*</Button>*/}

      {!isFullScreen ? (
        <Button
          {...buttonProps}
          style={{ border: "0" }}
          title={"Full screen"}
          onClick={onButtonClick(REPORT_ACTIONS.FULL_SCREEN)}
        >
          <IconLight icon={"expand-alt"} />
        </Button>
      ) : (
        <Button
          {...buttonProps}
          style={{ border: "0" }}
          title={"Small screen"}
          onClick={onButtonClick(REPORT_ACTIONS.SMALL_SCREEN)}
        >
          <IconLight icon={"compress-alt"} />
        </Button>
      )}
      {/*<Button*/}
      {/*{...buttonProps}*/}
      {/*shape={"circle"}*/}
      {/*title={"download CSV"}*/}
      {/*onClick={onButtonClick(REPORT_ACTIONS.DOWNLOAD_CSV)}*/}
      {/*>*/}
      {/*<IconLight icon={"arrow-to-bottom"} />*/}
      {/*</Button>*/}
    </div>
  );
};

CoreReportActionBar.propTypes = {
  isActive: PropTypes.bool.isRequired,
  onAction: PropTypes.func.isRequired,
  reportData: PropTypes.array.isRequired,
  isFullScreen: PropTypes.bool.isRequired
};

export default CoreReportActionBar;



// WEBPACK FOOTER //
// ./src/views/core/core_report_action_bar/CoreReportActionBar.jsx